import React from 'react';
import { StarDivider } from '../ui/StarDivider';
interface QuoteBandProps {
  quote?: string;
  author?: string;
}
export function QuoteBand({
  quote = 'Self-Defense isn’t just a right, it is also a Responsibility.',
  author = 'CCW Maggie'
}: QuoteBandProps) {
  return <section className="gutter section bg-midnight" aria-label="A word from our founder" data-id="element-238" data-mp="km88q2v177x3">
      <figure className="flex flex-col items-center text-center" data-id="element-239" data-mp="5xc0a4p2bsvy">
        <StarDivider data-id="element-240" data-mp="5vsg430acxow" />
        <blockquote className="mt-8 max-w-[22ch] font-display text-[clamp(2.25rem,5vw,6rem)] font-bold uppercase leading-[1.02] text-white" data-id="element-241" data-mp="5visgm2pr2md">
          “{quote}”
        </blockquote>
        <figcaption className="mt-8 font-display text-lg uppercase tracking-[0.16em] text-chrome-300" data-id="element-242" data-mp="3t3w71n5c7ve0">— {author}</figcaption>
      </figure>
    </section>;
}